import { gql } from '@apollo/client';

export const GET_CUSTOMER_PRODUCTS = gql`
  query GetCustomerProducts($customerId: Int!) {
    customerProducts(customerId: $customerId) {
      id
      name
      description
      isarchived
    }
  }
`;

export const ASSOCIATE_CUSTOMER_WITH_PRODUCT = gql`
  mutation AssociateCustomerWithProduct($customerId: Int!, $productId: Int!) {
    associateCustomerWithProduct(customerId: $customerId, productId: $productId) {
      success
      message
    }
  }
`;

export const REMOVE_CUSTOMER_PRODUCT_ASSOCIATION = gql`
  mutation RemoveCustomerProductAssociation($customerId: Int!, $productId: Int!) {
    removeCustomerProductAssociation(customerId: $customerId, productId: $productId) {
      success
      message
    }
  }
`;